module.exports = __webpack_public_path__ + "static/paso2soluciones-4db73a18909b617183b6bee4285667b6.svg";